import { toPairs, fromPairs, flow, map, isFunction } from 'lodash/fp';
import { Component } from 'react';
import { formValueSelector } from 'redux-form';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import getDisplayName from '../getDisplayName';

const createMapStateToProps = (params, configFormName) => (state, props) =>
  flow(
    (params) => (isFunction(params) ? params(props) : params),
    toPairs,
    map(([propName, fieldName]) => {
      return [
        propName,
        (state, { formName: propsFormName }) => {
          const formName = propsFormName || configFormName;

          return formName
            ? formValueSelector(formName)(state, fieldName)
            : undefined;
        },
      ];
    }),
    fromPairs,
    createStructuredSelector,
  )(params)(state, props);

export default (params, formName) => (WrappedComponent) => {
  const displayName = getDisplayName(WrappedComponent);
  const mapStateToProps = createMapStateToProps(params, formName);

  class FormValuesProvider extends Component {
    static displayName = `FormValuesProvider(${displayName})`;

    render() {
      return <WrappedComponent {...this.props} />;
    }
  }

  const ConnectedFormValuesProvider =
    connect(mapStateToProps)(FormValuesProvider);

  ConnectedFormValuesProvider.WrappedComponent = WrappedComponent;

  return ConnectedFormValuesProvider;
};
